import Vue from 'vue';
import HighlightsService from '../../components/widgets/highlights/service-highlights';
import ChangeCombiService from '../../services/changeCombi-request-service';
import OddHelperService from '../../services/odd-helper-service';

/**
 * Vuex store - Highlights matches module
 */
export const HighlightsModule = {
  state: {
    /**
     * This state property will contain all data for the highlights widget
     *
     */
    highlightsData: [],
    highlightsSportsData: [],
    selectedHighlightsSportId: 0,
    firstComboSelectionH: {},
    secondComboSelectionH: {},
    // disable duplicate async calls for same api method
    asyncHighlightsFlag: false,
    cashoutHiglightsFlag: false,
    loading: false,
  },
  mutations: {
    /**
     * Update sports data
     * @param state
     * @param data
     */
    addHighlightsSportData(state, data) {
      Vue.set(state, 'highlightsSportsData', data);
    },
    /**
     * Update matches data
     * @param state
     * @param data
     */
    addHighlightsData(state, data) {
      Vue.set(state, 'highlightsData', data);
    },
    updateHighlightsData(state, data) {
      state.highlightsData = data;
    },

    changeHighlightsSport(state, sportId) {
      state.selectedHighlightsSportId = sportId;
    },
    setFirstComboSelection(state, combo) {
      state.firstComboSelection = combo;
    },
    setSecondComboSelection(state, combo) {
      state.secondComboSelection = combo;
    },

    /**
     * Update async call flag
     * @param flag true/false flag value
     */
    updateAsyncHighlightsFlag(state, flag) {
      state.asyncHighlightsFlag = flag;
    },
    updateLoadingStatus(state, data) {
      state.loading = data;
    },
  },
  actions: {
    /**
     * Get all sports data
     * @param commit
     */
    getHighlightsItems({ commit, state }, params) {
      commit('updateLoadingStatus', true);
      // if object is already set, do not send new request
      if (state.asyncHighlightsFlag) {
        return;
      }
      const request = new HighlightsService();
      commit('updateAsyncHighlightsFlag', true);
      request.getParams.SportID = params.sportId;
      request.getParams.StartRecord = params.startRecord;
      request.getParams.EndRecord = params.endRecord;
      request.getParams.NumberOfOddTypes = params.numberOfOddTypes;
      request.getParams.IncludeAllSports = params.IncludeAllSports;
      // request.getParams.Minutes = params.minutes;
      request.execute((resp) => {
        // update store property with received api data
        commit('addHighlightsSportData', resp.data.s.map(String));
        commit('addHighlightsData', request.fillDate(resp.data));
        // send notification that async call is over
        commit('updateAsyncHighlightsFlag', false);
      }, () => {
        commit('updateAsyncHighlightsFlag', false);
      }).finally(() => {
        commit('updateLoadingStatus', false);
      });
    },
    /**
     * On combo selection get the new outcomes and map them to the loaded matches.
     */
    changeHighlightsCombi({ commit, state }, payload) {
      const changeCombiRequest = new ChangeCombiService();
      changeCombiRequest.getParams.MatchData = state.highlightsData.map(match => match.matchId);
      changeCombiRequest.getParams.OddType = payload.oddType;
      changeCombiRequest.getParams.isMostBalanced = payload.isMostBalanced;
      changeCombiRequest.getParams.Outcomes = payload.outcomes.map(o => o.id);
      changeCombiRequest.execute((resp) => {
        const highlights = JSON.parse(JSON.stringify(state.highlightsData));
        highlights.forEach((item, _index) => {
          const matchMarket = (resp.data !== null && typeof resp.data[item.matchId] !== 'undefined') ? resp.data[item.matchId][0] : {};
          let market = {
            id: payload.oddType,
            n: matchMarket.n || payload.name,
            m: matchMarket.m || OddHelperService.generateEmptyOutcomes(payload.outcomes.length),
            c: matchMarket.c || 0,
          };
          const idx = item.odds.findIndex(market => market.marketId === payload.oddType);
          if (idx >= 0) {
            item.odds[idx] = Object.assign({}, changeCombiRequest.mapOdds(market, item));
          } else {
            item.odds.push(changeCombiRequest.mapOdds(market, item));
          }
          item = Object.assign({}, item);
        });
        commit('updateHighlightsData', highlights);
      });
    },
  },
  getters: {
    /**
     * Get sport icon class
     * @param state
     * @returns {Function}
     */
    getHighlightsMatches(state) {
      return state.highlightsData;
    },
    getHighlightsSports(state) {
      return state.highlightsSportsData;
    },
    selectedHighlightsSportId(state) {
      let sportID = state.selectedHighlightsSportId;
      if (!sportID) {
        sportID = state.highlightsSportsData[0] || 0;
      }
      return Number.parseInt(sportID, 10);
    },
    getHighlightsLoadingStatus(state) {
      return state.loading;
    },
  },
};
